import styled from "styled-components"

const Container = styled("div")`
    width: 100vw;
    height: 150 px;
    background-color: cyan;
    margin: 25px; 
    justify-content: center;

    padding: 10 px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const ListItem = styled("li")`
    margin: 10px;  
`

 
const Roadmap = () => {
    return (
        <Container id="roadmap">

        <h1>WHAT IS THE BUFF MUSCLES NFT COLLECTION?</h1>
        
        <ul style={{padding: '0px 25%'}}>
        
        The Buff Muscles NFT collection is a uniquely-generated and handcrafted collection of wild wacky biceps just looking to live their lives to the fullest.

        </ul>

        </Container>

    )
}

export default Roadmap;